import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "../../../../../shared";

interface IDetailsCardItemTitleProps {
  title: string;
  customLineHeight?: string;
  showColon?: boolean;
}

const DetailsCardItemTitle = ({
  title,
  customLineHeight,
  showColon = true
}: IDetailsCardItemTitleProps) => {
  const { toMd, toLg, toSm } = useMediaQueries();

  const titleLineHeight = customLineHeight ?? "inherit";

  const PAPER_CARD_ITEM_TITLE_STYLE = toMd
    ? {
        minWidth: toSm ? "112px" : "156px",
        maxWidth: toSm ? "112px" : "156px"
      }
    : {
        minWidth: "112px",
        maxWidth: "112px",
        marginRight: toLg ? "2px" : "16px" // 2px is used to avoid wrapped numeric values
      };

  return (
    <Typography
      sx={[
        PAPER_CARD_ITEM_TITLE_STYLE,
        { lineHeight: titleLineHeight, color: colors.textSecondary }
      ]}
      variant="body2Medium"
    >
      {`${title}${showColon ? ":" : ""}`}
    </Typography>
  );
};

export default DetailsCardItemTitle;
